"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useShallowEqualSelector = void 0;

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _attributes = _interopRequireDefault(require("./attributes"));

var _locations = _interopRequireDefault(require("./locations"));

var _locationManager = _interopRequireDefault(require("./locationManager"));

var _organizations = _interopRequireDefault(require("./organizations"));

var _survey = _interopRequireDefault(require("./survey"));

var _sponsors = _interopRequireDefault(require("./sponsors"));

var _login = _interopRequireDefault(require("./login"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Main Redux reducer
 */
var RootReducer = (0, _redux.combineReducers)({
  attributes: _attributes.default,
  locations: _locations.default,
  locationManager: _locationManager.default,
  organizations: _organizations.default,
  login: _login.default,
  sponsors: _sponsors.default,
  survey: _survey.default
});
/**
 * Helper function for wrapping a selector with a shallowEqual equality function
 */

var useShallowEqualSelector = function useShallowEqualSelector(selector) {
  return (0, _reactRedux.useSelector)(selector, _reactRedux.shallowEqual);
};

exports.useShallowEqualSelector = useShallowEqualSelector;
var _default = RootReducer;
exports.default = _default;